import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ProductPage from '../../ProductPage';
import { showToastError } from '../../components/ToastNotifications';
import { useLegacyAppSession } from '../../contexts/LegacyAppSessionContext';
import useBrands from '../../hooks/useBrands';
import useMarkets from '../../hooks/useMarkets';

export default function ProductsContainer() {
  const navigate = useNavigate();
  const { org, currentUser } = useLegacyAppSession();
  const {
    data: brandOptions,
    isLoading: brandsLoading,
  } = useBrands({
    organizationId: org?.id ?? null,
    pageSize: 500,
    enabled: Boolean(org?.id),
    loadAll: true,
  });
  const {
    data: marketOptions,
    error: marketsError,
    isLoading: marketsLoading,
  } = useMarkets({
    organizationId: org?.id ?? null,
    enabled: Boolean(org?.id),
    scope: 'all',
  });

  useEffect(() => {
    if (!marketsError) return;
    showToastError('Market data could not be loaded. Please refresh the page or try again.');
  }, [marketsError]);

  return (
    <ProductPage
      organizationId={org?.id ?? null}
      brandOptions={brandOptions}
      marketOptions={marketOptions}
      lookupsReady={!brandsLoading && !marketsLoading}
      refreshKey={0}
      currentUser={currentUser}
      onImportProducts={() => navigate('/imports/metrc/auth', { state: { returnTo: '/products', workflow: 'products' } })}
      onAdd={() => navigate('/products/new')}
      onEdit={(product) => {
        const target = `/products/${product.id}/edit`;
        if (product.isArchived) {
          navigate(target, { state: { product } });
          return;
        }

        navigate(target);
      }}
    />
  );
}
